"use client";

import { useSeriesFavorite, useToast } from "app/hooks";
import { usePathname } from "next/navigation";
import { MouseEventHandler, useState, useSyncExternalStore } from "react";
import { MdStar, MdStarBorder } from "react-icons/md";
import { generateAuthLinkUrl } from "./AuthLink";
import { sessionStore } from "@lib/sessionStore";
import { controlMissionToast } from "@lib/utils";
import clsx from "clsx";

export function SeriesHeaderFavBtn({ seriesHash, mode }: { seriesHash: string; mode?: "ep" }) {
  const { session, sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const { results, isLoading, toggle } = useSeriesFavorite(
    seriesHash,
    sessionStatus === "authenticated",
  );
  const [isToggling, setIsToggling] = useState(false);

  const faved = results?.favoriteStatus?.favorite;
  const { pushToast } = useToast();
  const pathname = usePathname();
  const handleFav: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!session?.user) {
      return;
    }
    e.preventDefault();
    setIsToggling(true);
    toggle()
      .then((res) => {
        if (Array.isArray(res)) controlMissionToast(res, pushToast);
      })
      .finally(() => {
        setIsToggling(false);
      });
  };
  return (
    <a
      href={
        sessionStatus === "unauthenticated"
          ? generateAuthLinkUrl(pathname, undefined, "signin")
          : ""
      }
      onClick={handleFav}
      className={clsx(
        "series-h-fav",
        mode === "ep" ? " mode-ep" : "",
        isLoading ? " mode-loading" : faved ? " mode-faved" : "",
        session?.user ? "" : " mode-not-user",
        isToggling ? " mode-toggling" : "",
      )}
    >
      {mode !== "ep" && (
        <>
          {!faved && <MdStarBorder className="series-h-fav-icon" />}
          {faved && <MdStar className="series-h-fav-icon" />}
        </>
      )}
      {mode === "ep" && session?.user && (
        <>
          {!faved && (
            <>
              <MdStar className="series-h-fav-icon" />
              <span className="series-h-fav-label">お気に入りに追加する</span>
            </>
          )}
          {faved && (
            <>
              <MdStar className="series-h-fav-icon" />
              <span className="series-h-fav-label">お気に入り追加済</span>
            </>
          )}
        </>
      )}
      {mode === "ep" && !session?.user && (
        <>
          <MdStar className="series-h-fav-icon" />
          <span className="series-h-fav-label">登録してお気に入り</span>
        </>
      )}
    </a>
  );
}
